'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styles$c = require('./styles-1ad7f6ad.js');

var Carousel = function (_a) {
    var children = _a.children, title = _a.title, _b = _a.orientation, orientation = _b === void 0 ? 'horizontal' : _b, width = _a.width, height = _a.height;
    return (React__default.createElement(styles$c.Container, { className: "carousel", "data-testid": "carousel", width: width, orientation: orientation },
        React__default.createElement(styles$c.Title, { className: "carousel-title", "data-testid": "carousel-title" }, title),
        React__default.createElement(styles$c.ContainerList, { className: "carousel-list", "data-testid": "carousel-carousel-list", orientation: orientation, height: height }, React__default.Children.map(children, function (child) { return React__default.Children.only(child); }))));
};

exports.Carousel = Carousel;
